<template>
  <transition name="fade" leave-active-class="">
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  name: "CreditLayout"
};
</script>

<style scoped></style>
